export const reviews = [
  {
    id: 'rev-001',
    name: '李小明',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20young%20man%20with%20friendly%20smile%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    role: '漫画爱好者',
    rating: 5,
    title: '最好的韩漫网站',
    content: '一直在找韩国漫画资源，终于在这里找到了！更新速度很快，画质也很清晰，最重要的是完全免费。漫画种类非常丰富，从热血到恋爱都有，简直是我的快乐源泉！',
  },
  {
    id: 'rev-002',
    name: '张雨涵',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20young%20woman%20with%20gentle%20smile%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    role: '大学生',
    rating: 5,
    title: '每天都来看更新',
    content: '作为一个重度韩漫读者，我每天都要来刷一遍看有没有更新。网站界面简洁好用，分类清晰，找漫画非常方便。推荐给了好几个朋友，大家都说好！',
  },
  {
    id: 'rev-003',
    name: '王大鹏',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20young%20man%20with%20cool%20expression%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    role: '上班族',
    rating: 5,
    title: '下班后的放松时光',
    content: '工作压力大的时候，就喜欢找个好看的韩漫放松一下。这里的漫画资源太全了，连载和完结的都有，阅读体验非常棒。特别喜欢周末窝在沙发上看一整天。',
  },
  {
    id: 'rev-004',
    name: '陈思思',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20young%20woman%20with%20bright%20smile%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-04&orientation=squarish',
    role: '设计师',
    rating: 5,
    title: '画风精美内容优质',
    content: '作为一名设计师，我对画面的要求很高。这个网站的漫画画质真的没话说，每一部都是高清的。而且分类筛选功能做得很好，能快速找到我喜欢的恋爱类型。',
  },
  {
    id: 'rev-005',
    name: '赵强',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20man%20with%20warm%20expression%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-05&orientation=squarish',
    role: '自由职业者',
    rating: 4,
    title: '韩漫资源很丰富',
    content: '相比其他漫画网站，这里的韩国漫画资源是最全的。很多冷门的韩漫也能找到，更新也及时。就是希望手机端能有App就更好了，目前用浏览器看也很方便。',
  },
  {
    id: 'rev-006',
    name: '林小燕',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20avatar%2C%20young%20woman%20with%20cute%20expression%2C%20clean%20simple%20portrait%2C%20neutral%20background%2C%20semi-realistic%20anime%20style&width=200&height=200&seq=avatar-06&orientation=squarish',
    role: '高中生',
    rating: 5,
    title: '同学都在用这个网站',
    content: '班上好多同学都在用韩漫画网看漫画，我也跟着入坑了。最喜欢《女神降临》，已经追完了！现在每天都在追新番，感谢网站提供这么好的漫画资源！',
  },
];